import { InformationCircleIcon } from "@heroicons/react/24/solid";
import React from "react";
import { Tooltip } from "@chakra-ui/react";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function MatchingEstimateTooltip(props) {
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(Tooltip, {
      hasArrow: true,
      closeDelay: 1000,
      placement: "bottom-end",
      label: /*#__PURE__*/_jsx("p", {
        className: "text-xs p-1 pointer-events-auto select-all",
        children: props.isEligible ? /*#__PURE__*/_jsxs(_Fragment, {
          children: ["Due to the nature of quadratic funding, this estimated match is subject to change as the round progresses. Your match may start at $0, but can change as the project receives more donations. Read more about how quadratic funding works", " ", /*#__PURE__*/_jsx("a", {
            href: "https://wtfisqf.com",
            className: "underline",
            target: "_blank",
            children: "here"
          }), "."]
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: ["Keep in mind that this is a potential match that may change with the number of donations to a round.", /*#__PURE__*/_jsx("a", {
            href: "https://passport.gitcoin.co",
            className: "underline",
            target: "_blank",
            children: "Click here"
          }), " ", "to configure your score."]
        })
      }),
      id: "matching-estimate-tooltip",
      className: "max-w-sm bg-gray-500 text-gray-50",
      children: /*#__PURE__*/_jsx(InformationCircleIcon, {
        "data-background-color": "#5932C4",
        className: "inline w-4 h-4 ml-2",
        "data-testid": "matching-estimate-tooltip"
      })
    })
  });
}